<template>
  <div class="userCenter">
    <div class="boxCenter">
      <div class="userBox">
        <LeftSide></LeftSide>
        <div class="userRight">
          <div class="userTitle">个人中心<span class="editBtn" @click="editFn" v-show="!editFlag">编辑</span></div>
          <div class="userInfoBox">
            <el-form ref="form" :model="formData" :rules="rules" label-width="161px">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="formData.name" placeholder="请输入姓名" :disabled="!editFlag"></el-input>
              </el-form-item>
              <el-form-item label="身份证" prop="idNumber">
                <el-input v-model="formData.idNumber" placeholder="请输入身份证" :disabled="!editFlag"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="phoneNum">
                <el-input v-model="formData.phoneNum" placeholder="请输入号码" :disabled="!editFlag"></el-input>
              </el-form-item>
              <el-form-item label="联系地址" prop="address">
                <el-input v-model="formData.address" placeholder="请输入地址" :disabled="!editFlag"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系人姓名" prop="emergPerson">
                <el-input v-model="formData.emergPerson" placeholder="请输入姓名" :disabled="!editFlag"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系人号码" prop="emergPhone">
                <el-input v-model="formData.emergPhone" placeholder="请输入号码" :disabled="!editFlag"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="editBox" v-show="editFlag">
            <span class="save" @click="save">保存</span>
            <span @click="editClose">取消</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LeftSide from './common/leftside'
  import store from '@/store/index.js'
  import eventVue from '../bus.js'
  export default {
    components: {
      LeftSide
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    watch: {
      userData: {
        handler(newName, oldName){
          if (newName) {
            this.initData()
          }
        },
        immediate: true
      }
    },
    data(){
      return {
        formData:{
          name:'',
          phoneNum:'',
          idNumber:'',
          address:'',
          emergPerson:'',
          emergPhone:''
        },
        rules:{
          name:[{required: true, trigger: 'blur',message:'请输入姓名'},],
          idNumber:[{required: true, trigger: 'blur',message:'请输入身份证'},],
          phoneNum:[{required: true, trigger: 'blur',message:'请输入手机号码'},],
          address:[{required: true, trigger: 'blur',message:'请输入联系地址'},],
          emergPerson:[{required: true, trigger: 'blur',message:'请输入紧急联系人'},],
          emergPhone:[{required: true, trigger: 'blur',message:'请输入紧急联系人号码'},]
        },
        editFlag:false
      }
    },
    created(){
      if (this.userData) {
        this.initData()
      }
    },
    mounted(){
      //this.loadData()
      eventVue.$emit("leftSwitch",'1')
    },
    methods:{
      initData(){
        this.formData.name = this.userData.name
        this.formData.phoneNum = this.userData.phoneNum
        this.formData.idNumber = this.userData.idNumber
        this.formData.address = this.userData.address
        this.formData.emergPerson = this.userData.emergPerson
        this.formData.emergPhone = this.userData.emergPhone
        this.editFlag = false
      },

      editFn(){
        this.editFlag = true
      },
      editClose(){
        this.editFlag = false
        this.$refs.form.resetFields();
        //this.loadData(this.userId)
      },
      save(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.$https.post('/api/member/updateMember?name='+this.formData.name+'&id='+this.userData.id+'&phoneNum='+this.formData.phoneNum+'&idNumber='+this.formData.idNumber+'&address='
              +this.formData.address+'&emergPerson='+this.formData.emergPerson+'&emergPhone='+this.formData.emergPhone).then((response)=>{
                  this.$https.get('/api/member/memberId/'+this.userData.id).then((response)=>{
                    store.state.userData = response.data
                  });
                //store.state.userData = response.data
                  //this.loadData(this.userId)
                  this.editFlag = false
              }).catch((error) => {});
          }
        })
      }
    }
  }
</script>

<style scoped>
  .userInfoBox{
    width: 454px;
    padding-top: 24px;
  }
  .editBtn{
    position: absolute;
    color: #5680f9;
    right: 20px;
    top: 14px;
    font-size: 16px;
    cursor: pointer;
  }
  .editBox{
    padding:27px 0 0 193px;
    overflow: hidden;
  }
  .editBox span{
    float: left;
    width: 96px;
    text-align: center;
    height: 38px;
    line-height: 38px;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
    font-size: 14px;
    color: #919191;
    margin-right: 20px;
    cursor: pointer;
  } 
  .editBox .save{
    color: #ffffff;
    background: #FFCD30;
    border: 1px solid #FFCD30;
  }
</style>



// WEBPACK FOOTER //
// src/components/userCenter.vue